<div
  *ngIf="showAllCompetencies"
  class="competency-card-grid">
  <competency-card
    *ngFor="let competency of competencies"
    [competency]="competency"
    [cardType]="cardType">
  </competency-card>
</div>

<div class="toc-competency-toggle" *ngIf="competencies.length">
  <button type="button" class="btn btn-link btn-sm" (click)="toggleCompetencies()">
    <span *ngIf="!showAllCompetencies">Show competencies ({{ competencies.length }})</span>
    <span *ngIf="showAllCompetencies">Hide competencies</span>
  </button>
</div>
